import React from "react";
import { Link } from "react-router-dom";
import { useLang } from "@/context/LangContext";
import { useAuth } from "@/context/AuthContext";
import { ArrowRight } from "@phosphor-icons/react";

const EXPLORE = { en: "Explore services", nl: "Diensten bekijken", pl: "Przeglądaj usługi", it: "Esplora i servizi", sk: "Preskúmať služby", es: "Explorar servicios", pt: "Explorar serviços" };

export default function Splash() {
  const { t, lang } = useLang(); // eslint-disable-line no-unused-vars
  const { user } = useAuth();

  return (
    <div className="splash relative flex min-h-screen flex-col items-center justify-center overflow-hidden px-6" data-testid="splash-page">
      <div className="splash-blob splash-blob-a" aria-hidden="true" />
      <div className="splash-blob splash-blob-b" aria-hidden="true" />
      <div className="splash-blob splash-blob-c" aria-hidden="true" />

      <div className="splash-stage relative grid place-items-center px-6 py-6">
        <div className="splash-logo-wrap">
          <img
            src="/plinplincare-wordmark-dark.png"
            alt="PlinPlinCare"
            data-testid="splash-logo"
            className="splash-logo h-10 w-auto object-contain sm:h-14"
          />
          <span className="splash-shine" aria-hidden="true" style={{ WebkitMaskImage: "url(/plinplincare-wordmark-dark.png)", maskImage: "url(/plinplincare-wordmark-dark.png)" }} />
        </div>
        <p className="splash-tagline mt-5 text-center text-sm text-ppc-muted sm:text-base">Home Services on Demand and Beyond</p>
      </div>

      <div className="splash-actions mt-10 flex w-full max-w-xs flex-col gap-2.5" data-testid="splash-actions">
        {user ? (
          <Link to="/dashboard" data-testid="splash-dashboard-btn" className="btn-primary grid h-[50px] place-items-center rounded-[14px] text-[15px]">
            {t("nav_dashboard")}
          </Link>
        ) : (
          <>
            <Link to="/login" data-testid="splash-login-btn" className="btn-primary grid h-[50px] place-items-center rounded-[14px] text-[15px]">
              {t("nav_login")}
            </Link>
            <Link to="/register" data-testid="splash-register-btn" className="btn-secondary grid h-[50px] place-items-center rounded-[14px] text-[15px]">
              {t("nav_register")}
            </Link>
          </>
        )}
        <Link to="/home" data-testid="splash-explore-link" className="mt-2 inline-flex items-center justify-center gap-1.5 text-sm text-primary-green">
          {EXPLORE[lang] || EXPLORE.en} <ArrowRight size={14} />
        </Link>
      </div>
    </div>
  );
}
